export enum RuleValueFormat {
  CENTS = "CENTS",
  DOLLARS = "DOLLARS",
  GRAMS = "GRAMS",
  HIDDEN = "HIDDEN",
  KILOGRAMS = "KILOGRAMS",
  PERCENT = "PERCENT",
  UNITS = "UNITS",
}

export const RuleValueFormatDisplayName = {
  [RuleValueFormat.CENTS]: "Cents (\xA2)",
  [RuleValueFormat.DOLLARS]: "Dollars ($)",
  [RuleValueFormat.GRAMS]: "Grams (g)",
  [RuleValueFormat.HIDDEN]: "Not Shown",
  [RuleValueFormat.KILOGRAMS]: "Kilograms (kg)",
  [RuleValueFormat.PERCENT]: "Percent (%)",
  [RuleValueFormat.UNITS]: "Units",
};

export const RuleValueFormatByRawValueFormat = {
  [RuleValueFormat.CENTS]: [
    RuleValueFormat.CENTS,
    RuleValueFormat.DOLLARS,
    RuleValueFormat.HIDDEN,
    RuleValueFormat.UNITS,
  ],

  [RuleValueFormat.DOLLARS]: [
    RuleValueFormat.CENTS,
    RuleValueFormat.DOLLARS,
    RuleValueFormat.HIDDEN,
    RuleValueFormat.UNITS,
  ],

  [RuleValueFormat.GRAMS]: [
    RuleValueFormat.GRAMS,
    RuleValueFormat.HIDDEN,
    RuleValueFormat.KILOGRAMS,
    RuleValueFormat.UNITS,
  ],

  [RuleValueFormat.KILOGRAMS]: [
    RuleValueFormat.GRAMS,
    RuleValueFormat.HIDDEN,
    RuleValueFormat.KILOGRAMS,
    RuleValueFormat.UNITS,
  ],

  [RuleValueFormat.PERCENT]: [
    RuleValueFormat.HIDDEN,
    RuleValueFormat.PERCENT,
    RuleValueFormat.UNITS,
  ],

  [RuleValueFormat.UNITS]: [
    RuleValueFormat.CENTS,
    RuleValueFormat.DOLLARS,
    RuleValueFormat.GRAMS,
    RuleValueFormat.HIDDEN,
    RuleValueFormat.KILOGRAMS,
    RuleValueFormat.PERCENT,
    RuleValueFormat.UNITS,
  ],
};

export const ValueSource = {
  CONSTANT: "CONSTANT",
  COUNT: "COUNT",
  DEPENDENCY_VALUE: "DEPENDENCY_VALUE",
  FIELD: "FIELD",
  GLOBAL_BUSINESS: "GLOBAL_BUSINESS",
  RULESET_FIELD: "RULESET_FIELD",
  SUM: "SUM",
} as const;
